import Api from '@/api/index';

const ReturnedCheck = {
  namespaced: true,
  state: {
    allReturnedChecks: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllReturnedChecks(state, checks) {
      state.allReturnedChecks = [...checks]
      
    },

    updateOneReturnedCheck(state, {check, idx = null}){
      idx = idx || state.allReturnedChecks.findIndex(c => c.id == check.id)
      if (idx > -1){
        state.allReturnedChecks.splice(idx, 1, {...check})
      }
    },
    removeOneReturnedCheck(state, {check, idx = null}){
      idx = idx || state.allReturnedChecks.findIndex(c => c.id == check.id)
      if (idx > -1){
        state.allReturnedChecks.splice(idx, 1,)
      }
    }

    // this.status_missed_id = state.allReturnedChecks.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allReturnedChecks.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.ReturnedCheck.index(filters).then(r => r.data).then(r => {
        context.commit('setAllReturnedChecks', r.data)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default ReturnedCheck;
